import React from 'react'

export default function Contactus() {
    return (
        <div>
            THis is Contact us part of quick info
        </div>
    )
}
